/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';

export const RenderMostRecentProjectSection = ({
	projectItem,
}: {
	projectItem: React.JSX.Element | null;
}): false | React.JSX.Element => {
	return (
		!!projectItem && (
			// eslint-disable-next-line jira/integration/test-id-by-folder-structure
			<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.most-recent-project-section.most-recent-project-section">
				<MenuSection>
					{/* We need to wrap the projectItem in a MenuList since projectItem has role 'listitem'
					which needs a parent with role 'list' */}
					<MenuList>{projectItem}</MenuList>
				</MenuSection>
			</MenuListItem>
		)
	);
};
